import { Deserializable } from '../../deserializable';

export class ApplicantOfferPreferenceDto implements Deserializable {
  public ApplicantIdentifier: string;
  public Forename: string;
  public Surname: string;
  public TitleCode: string;
  public EmailAddress: string;
  public PhoneNumber: string;
  public DateOfBirth?: Date;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
